import { observer } from 'mobx-react';
import { Draggable } from '@hello-pangea/dnd';
import LearningCollectionEditStore from '../../../Edit/Store';
import LearningDesignExperienceStore from '../../../Experience/Store';
import { ModifiableExperiencesContext } from '../../../Types';
import CustomizeRow from './CustomizeRow';

interface Props {
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
  experienceStores: ReadonlyArray<LearningDesignExperienceStore>;
}

function DraggableRow({ context, learningCollectionStore, experienceStores }: Props) {
  return experienceStores.map((experienceStore, index) => (
    <Draggable
      index={index}
      key={experienceStore.experienceResource.payload.id}
      draggableId={String(experienceStore.experienceResource.payload.id)}
    >
      {(provided) => (
        <tr
          className="border-b border-l-1 border-r-1"
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <CustomizeRow
            context={context}
            store={learningCollectionStore}
            experienceResource={experienceStore.experienceResource}
            dragHandleProps={provided.dragHandleProps}
          />
        </tr>
      )}
    </Draggable>
  ));
}

export default observer(DraggableRow);
